import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BrandLoader from "@/components/BrandLoader";

export default function ProtectedRoute({ children, adminOnly = false, feature = null, viewRoles = [] }) {
  const { user, loading, can } = useAuth();
  const location = useLocation();

  if (loading) {
    return <BrandLoader fullscreen label="Connexion à la plateforme…" />;
  }
  if (!user) return <Navigate to="/" state={{ returnTo: location.pathname + location.search }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (feature && !can(feature) && !viewRoles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

